import axios from 'axios'
import Cookie from "js-cookie";

export default new class {

    get __token_key() { return '_hp_access'; }
    get __refresh_key() { return '_hp_refresh'; }

    constructor() {
        this.client = axios.create({
            baseURL: process.env.VUE_APP_AUTH_SERVICE_API_URL,
            headers: {
                'Content-type': 'application/json'
            }
        });
    }

    async post(url, data) {
        let headers = null;

        if(data != undefined && data.grant_type == 'google_web') {
            headers = {Authorization: "Bearer " + data.token};
        }
        else {
            headers = this.getAuthorizationHeaders()
        }

        const response = await this.client.post(url, data, {...headers});
        return response.data;
    }

    async get(url) {
        const headers = this.getAuthorizationHeaders()
        const response = await this.client.get(url, {...headers});
        return response.data;
    }

    getAuthorizationHeaders() {
        return {
            headers: {'Authorization': (this.hasTokens()) ? 'Bearer ' + this.getToken() : '' }
        }
    }

    hasTokens() {
        return Cookie.get(this.__token_key) !== undefined 
            && Cookie.get(this.__token_key) !== null
            && Cookie.get(this.__refresh_key) !== undefined
            && Cookie.get(this.__refresh_key) !== null;
    }

    getToken(key = 'access_token') {
        let keys = {
            'access_token' : this.__token_key,
            'refresh_token': this.__refresh_key
        }

        if (key !== null) return Cookie.get(keys[key]);

        return {
            'access_token' : Cookie.get(this.__token_key),
            'refresh_token' : Cookie.get(this.__refresh_key)
        }

    }
};